// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TenantPresentationTemplateTableQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TenantPresentationTemplateTableQuery = { __typename?: 'Query', presentationTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & TenantPresentationTemplateTable_PresentationTemplateFragment
      ) | null } | null> | null } };

export type TenantPresentationTemplateTable_PresentationTemplateFragment = { __typename?: 'PresentationTemplate', id: string, displayName: string, isPinned: boolean, type: Types.PresentationTemplateType, tenantID: string, luminaryOrganizationID?: string | null, systemTemplateKind?: Types.PresentationTemplateSystemTemplateKind | null, createdAt: Time, updatedAt: Time, user?: { __typename?: 'User', id: string, displayName: string } | null };

export type DeletePresentationTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeletePresentationTemplateMutation = { __typename?: 'Mutation', deletePresentationTemplate?: number | null };

export type DuplicatePresentationTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  type: Types.PresentationTemplateType;
}>;


export type DuplicatePresentationTemplateMutation = { __typename?: 'Mutation', duplicatePresentationTemplate?: { __typename?: 'PresentationTemplate', id: string } | null };

export type UpdatePresentationTemplatePinMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  isPinned: Types.Scalars['Boolean']['input'];
}>;


export type UpdatePresentationTemplatePinMutation = { __typename?: 'Mutation', updatePresentationTemplate: { __typename?: 'PresentationTemplate', id: string, isPinned: boolean } };

export type PublishPresentationTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PublishPresentationTemplateMutation = { __typename?: 'Mutation', publishPresentationTemplate: { __typename?: 'PresentationTemplate', id: string } };

export type UnpublishPresentationTemplateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type UnpublishPresentationTemplateMutation = { __typename?: 'Mutation', unpublishPresentationTemplate: { __typename?: 'PresentationTemplate', id: string } };

export const Operations = {
  Query: {
    TenantPresentationTemplateTable: 'TenantPresentationTemplateTable' as const
  },
  Mutation: {
    DeletePresentationTemplate: 'DeletePresentationTemplate' as const,
    DuplicatePresentationTemplate: 'DuplicatePresentationTemplate' as const,
    UpdatePresentationTemplatePin: 'UpdatePresentationTemplatePin' as const,
    PublishPresentationTemplate: 'PublishPresentationTemplate' as const,
    UnpublishPresentationTemplate: 'UnpublishPresentationTemplate' as const
  },
  Fragment: {
    TenantPresentationTemplateTable_PresentationTemplate: 'TenantPresentationTemplateTable_PresentationTemplate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const TenantPresentationTemplateTable_PresentationTemplateFragmentDoc = gql`
    fragment TenantPresentationTemplateTable_PresentationTemplate on PresentationTemplate {
  id
  displayName
  isPinned
  type
  tenantID
  luminaryOrganizationID
  systemTemplateKind
  createdAt
  updatedAt
  user {
    id
    displayName
  }
}
    `;
export const TenantPresentationTemplateTableDocument = gql`
    query TenantPresentationTemplateTable {
  presentationTemplates(
    where: {and: [{type: TENANT_TEMPLATE}, {systemTemplateKindIsNil: true}]}
    orderBy: [{field: updated_at, direction: DESC}]
  ) {
    edges {
      node {
        ...TenantPresentationTemplateTable_PresentationTemplate
      }
    }
  }
}
    ${TenantPresentationTemplateTable_PresentationTemplateFragmentDoc}`;

/**
 * __useTenantPresentationTemplateTableQuery__
 *
 * To run a query within a React component, call `useTenantPresentationTemplateTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantPresentationTemplateTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantPresentationTemplateTableQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantPresentationTemplateTableQuery(baseOptions?: Apollo.QueryHookOptions<TenantPresentationTemplateTableQuery, TenantPresentationTemplateTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantPresentationTemplateTableQuery, TenantPresentationTemplateTableQueryVariables>(TenantPresentationTemplateTableDocument, withFetchPolicyContext(options));
      }
export function useTenantPresentationTemplateTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantPresentationTemplateTableQuery, TenantPresentationTemplateTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantPresentationTemplateTableQuery, TenantPresentationTemplateTableQueryVariables>(TenantPresentationTemplateTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useTenantPresentationTemplateTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TenantPresentationTemplateTableQuery, TenantPresentationTemplateTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TenantPresentationTemplateTableQuery, TenantPresentationTemplateTableQueryVariables>(TenantPresentationTemplateTableDocument, withFetchPolicyContext(options));
        }
export type TenantPresentationTemplateTableQueryHookResult = ReturnType<typeof useTenantPresentationTemplateTableQuery>;
export type TenantPresentationTemplateTableLazyQueryHookResult = ReturnType<typeof useTenantPresentationTemplateTableLazyQuery>;
export type TenantPresentationTemplateTableSuspenseQueryHookResult = ReturnType<typeof useTenantPresentationTemplateTableSuspenseQuery>;
export type TenantPresentationTemplateTableQueryResult = Apollo.QueryResult<TenantPresentationTemplateTableQuery, TenantPresentationTemplateTableQueryVariables>;
export const DeletePresentationTemplateDocument = gql`
    mutation DeletePresentationTemplate($id: ID!) {
  deletePresentationTemplate(templateID: $id)
}
    `;
export type DeletePresentationTemplateMutationFn = Apollo.MutationFunction<DeletePresentationTemplateMutation, DeletePresentationTemplateMutationVariables>;

/**
 * __useDeletePresentationTemplateMutation__
 *
 * To run a mutation, you first call `useDeletePresentationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePresentationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePresentationTemplateMutation, { data, loading, error }] = useDeletePresentationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePresentationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeletePresentationTemplateMutation, DeletePresentationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePresentationTemplateMutation, DeletePresentationTemplateMutationVariables>(DeletePresentationTemplateDocument, options);
      }
export type DeletePresentationTemplateMutationHookResult = ReturnType<typeof useDeletePresentationTemplateMutation>;
export type DeletePresentationTemplateMutationResult = Apollo.MutationResult<DeletePresentationTemplateMutation>;
export type DeletePresentationTemplateMutationOptions = Apollo.BaseMutationOptions<DeletePresentationTemplateMutation, DeletePresentationTemplateMutationVariables>;
export const DuplicatePresentationTemplateDocument = gql`
    mutation DuplicatePresentationTemplate($id: ID!, $type: PresentationTemplateType!) {
  duplicatePresentationTemplate(templateID: $id, type: $type) {
    id
  }
}
    `;
export type DuplicatePresentationTemplateMutationFn = Apollo.MutationFunction<DuplicatePresentationTemplateMutation, DuplicatePresentationTemplateMutationVariables>;

/**
 * __useDuplicatePresentationTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicatePresentationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicatePresentationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicatePresentationTemplateMutation, { data, loading, error }] = useDuplicatePresentationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDuplicatePresentationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DuplicatePresentationTemplateMutation, DuplicatePresentationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicatePresentationTemplateMutation, DuplicatePresentationTemplateMutationVariables>(DuplicatePresentationTemplateDocument, options);
      }
export type DuplicatePresentationTemplateMutationHookResult = ReturnType<typeof useDuplicatePresentationTemplateMutation>;
export type DuplicatePresentationTemplateMutationResult = Apollo.MutationResult<DuplicatePresentationTemplateMutation>;
export type DuplicatePresentationTemplateMutationOptions = Apollo.BaseMutationOptions<DuplicatePresentationTemplateMutation, DuplicatePresentationTemplateMutationVariables>;
export const UpdatePresentationTemplatePinDocument = gql`
    mutation UpdatePresentationTemplatePin($id: ID!, $isPinned: Boolean!) {
  updatePresentationTemplate(input: {id: $id, update: {isPinned: $isPinned}}) {
    id
    isPinned
  }
}
    `;
export type UpdatePresentationTemplatePinMutationFn = Apollo.MutationFunction<UpdatePresentationTemplatePinMutation, UpdatePresentationTemplatePinMutationVariables>;

/**
 * __useUpdatePresentationTemplatePinMutation__
 *
 * To run a mutation, you first call `useUpdatePresentationTemplatePinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePresentationTemplatePinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePresentationTemplatePinMutation, { data, loading, error }] = useUpdatePresentationTemplatePinMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isPinned: // value for 'isPinned'
 *   },
 * });
 */
export function useUpdatePresentationTemplatePinMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePresentationTemplatePinMutation, UpdatePresentationTemplatePinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePresentationTemplatePinMutation, UpdatePresentationTemplatePinMutationVariables>(UpdatePresentationTemplatePinDocument, options);
      }
export type UpdatePresentationTemplatePinMutationHookResult = ReturnType<typeof useUpdatePresentationTemplatePinMutation>;
export type UpdatePresentationTemplatePinMutationResult = Apollo.MutationResult<UpdatePresentationTemplatePinMutation>;
export type UpdatePresentationTemplatePinMutationOptions = Apollo.BaseMutationOptions<UpdatePresentationTemplatePinMutation, UpdatePresentationTemplatePinMutationVariables>;
export const PublishPresentationTemplateDocument = gql`
    mutation PublishPresentationTemplate($id: ID!) {
  publishPresentationTemplate(id: $id) {
    id
  }
}
    `;
export type PublishPresentationTemplateMutationFn = Apollo.MutationFunction<PublishPresentationTemplateMutation, PublishPresentationTemplateMutationVariables>;

/**
 * __usePublishPresentationTemplateMutation__
 *
 * To run a mutation, you first call `usePublishPresentationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishPresentationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishPresentationTemplateMutation, { data, loading, error }] = usePublishPresentationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishPresentationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<PublishPresentationTemplateMutation, PublishPresentationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishPresentationTemplateMutation, PublishPresentationTemplateMutationVariables>(PublishPresentationTemplateDocument, options);
      }
export type PublishPresentationTemplateMutationHookResult = ReturnType<typeof usePublishPresentationTemplateMutation>;
export type PublishPresentationTemplateMutationResult = Apollo.MutationResult<PublishPresentationTemplateMutation>;
export type PublishPresentationTemplateMutationOptions = Apollo.BaseMutationOptions<PublishPresentationTemplateMutation, PublishPresentationTemplateMutationVariables>;
export const UnpublishPresentationTemplateDocument = gql`
    mutation UnpublishPresentationTemplate($id: ID!) {
  unpublishPresentationTemplate(id: $id) {
    id
  }
}
    `;
export type UnpublishPresentationTemplateMutationFn = Apollo.MutationFunction<UnpublishPresentationTemplateMutation, UnpublishPresentationTemplateMutationVariables>;

/**
 * __useUnpublishPresentationTemplateMutation__
 *
 * To run a mutation, you first call `useUnpublishPresentationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishPresentationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishPresentationTemplateMutation, { data, loading, error }] = useUnpublishPresentationTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpublishPresentationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UnpublishPresentationTemplateMutation, UnpublishPresentationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnpublishPresentationTemplateMutation, UnpublishPresentationTemplateMutationVariables>(UnpublishPresentationTemplateDocument, options);
      }
export type UnpublishPresentationTemplateMutationHookResult = ReturnType<typeof useUnpublishPresentationTemplateMutation>;
export type UnpublishPresentationTemplateMutationResult = Apollo.MutationResult<UnpublishPresentationTemplateMutation>;
export type UnpublishPresentationTemplateMutationOptions = Apollo.BaseMutationOptions<UnpublishPresentationTemplateMutation, UnpublishPresentationTemplateMutationVariables>;